import { render, staticRenderFns } from "./goodsin.vue?vue&type=template&id=20000b3e&"
import script from "./goodsin.vue?vue&type=script&lang=js&"
export * from "./goodsin.vue?vue&type=script&lang=js&"
import style0 from "./goodsin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20000b3e')) {
      api.createRecord('20000b3e', component.options)
    } else {
      api.reload('20000b3e', component.options)
    }
    module.hot.accept("./goodsin.vue?vue&type=template&id=20000b3e&", function () {
      api.rerender('20000b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goodsin/goodsin.vue"
export default component.exports